import { Row, Column } from '@shipt/design-system-layouts'
import { Headline } from '@shipt/design-system-typography'
import { SkeletonConsumer } from '@/features/shared/components/SkeletonLoader'
import { TextButtonLink } from '@/features/shared/elements/Link/Buttons'
import { renderElement } from '@/features/cms/components/CMS/RichTextRenderer'
import styled from 'styled-components'
import { type ShelfHeaderData } from '@/features/cms/components/CMS/types'
import { theme } from '@/features/shared/constants/shiptTheme'

type Props = Pick<ShelfHeaderData['data'], 'heading' | 'subheading'> & {
  linkUrl: string | undefined
}
export const BentoBoxHeader = (props: Props) => {
  const { heading, subheading, linkUrl } = props
  const richTextElements = subheading?.elements ?? []

  return (
    <Row align="center" justify="space-between" marginBottom="md" marginTop="3xl">
      <Column>
        {!!heading && (
          <Row align="center">
            <SkeletonConsumer width={130} height={24}>
              <Headline as="h2">{heading}</Headline>
            </SkeletonConsumer>
          </Row>
        )}
        {richTextElements.length > 0 && (
          <HeaderSubheading>{richTextElements.map(renderElement)}</HeaderSubheading>
        )}
      </Column>

      {!!linkUrl && (
        <SkeletonConsumer width={95} height={24}>
          <TextButtonLink aria-label={`View all ${heading}`} href={linkUrl}>
            View all
          </TextButtonLink>
        </SkeletonConsumer>
      )}
    </Row>
  )
}

const HeaderSubheading = styled.div`
  *,
  & {
    line-height: 1.25rem;
    color: ${theme.color.content.base.neutral.secondary};
  }
`
